import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';

declare const Charismatic: any;

@Component({
  selector: 'casinobs-component',
  templateUrl: '../sharedTemplates/casinobs.component.html',
})
export class CasinoBSComponent implements AfterViewInit {
  gameid;
  productid;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.gameid = params['gameid'];
      this.productid = params['productid'];
    });
  }

  ngAfterViewInit() {
    if (this._UserHelper.isSignedIn) {
      this.getCasinoXPGames();
    }

    this._UiHelper.setNavbarTitle('Casino', true);
  }

  getCasinoXPGames() {
    let platform;
    if (environment.mobile) {
      platform = 'mobile';
    } else {
      platform = 'desktop';
    }

    this._ApiService.CasinoBSGameLaunch(this.gameid, this.productid, platform, this._LocalizationService.LANGCODE).then(x => {
      ////console.warn(x);
      window.location.href = x;
    });
  }
}
